const headerBg = () => {
    $(window).on('scroll', function () {
        if ($('#fv').height() < $(this).scrollTop()) {
            $('#header').removeClass('bg-transparent');
            $('#header').addClass('bg-primary/80');
        } else {
            $('#header').addClass('bg-transparent');
            $('#header').removeClass('bg-primary/80');
        }
        if ($('#fv-white').height() < $(this).scrollTop()) {
            $('#header').removeClass('bg-transparent');
            $('#header').addClass('bg-secondary/90');
        } else {
            $('#header').addClass('bg-transparent');
            $('#header').removeClass('bg-secondary/90');
        }
    });
};

export default headerBg